import { ModalsWrapperContext } from '@kanda-libs/ks-design-library';
import { useCallback, useContext } from 'react';
import { HELP_MODAL_ID } from './constants';

export interface HelpModalHook {
  showHelpModal: () => void;
  hideHelpModal: () => void;
}

export default function useHelpModal(): HelpModalHook {
  const { showModal, hideModal } = useContext(ModalsWrapperContext);

  const showHelpModal = useCallback(
    () => showModal(HELP_MODAL_ID),
    [showModal],
  );

  const hideHelpModal = useCallback(
    () => hideModal(HELP_MODAL_ID),
    [hideModal],
  );

  return {
    showHelpModal,
    hideHelpModal,
  };
}
